import { A } from '@adornis/base/env-info.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { ParticipationEinzelberatung } from '../entities/ParticipationEinzelberatung.js';
import { Category } from '../entities/category.js';
import { Einzelberatung } from '../entities/einzelberatung.js';

@Entity()
export class EinzelberatungDataview extends AdornisEntity {
  static override _class = 'EinzelberatungDataview';

  static override resolveID(entity: EinzelberatungDataview): string {
    if (!entity._id) return (entity._id = A.getGloballyUniqueID());
    return entity._id;
  }

  @validate(nonOptional())
  @Field(type => String)
  _id!: string;

  @validate(nonOptional())
  @Field(type => Einzelberatung)
  einzelberatung!: Einzelberatung;

  @validate(nonOptional())
  @Field(type => Category)
  category!: Category;

  @validate(nonOptional())
  @Field(type => [ParticipationEinzelberatung], { default: v => v ?? [] })
  participations!: ParticipationEinzelberatung[];

  public static get neededGqlFields(): BaseQLSelectionSet<EinzelberatungDataview> {
    return {
      _id: 1,
      _class: 1,
      category: {
        _class: 1,
        name: 1,
      },
      einzelberatung: {
        _id: 1,
        _class: 1,
        name: 1,
        sortingWeight: 1,
        slotConfig: {
          _id: 1,
          _class: 1,
          start: 1,
          end: 1,
          hasLunchBreak: 1,
          startLunch: 1,
          endLunch: 1,
          slotDuration: 1,
        },
        slots: { _id: 1, _class: 1, beraterID: 1, start: 1, end: 1 },
        participationCount: 1,
      },
      participations: {
        _id: 1,
        _class: 1,
        state: 1,
      },
    } as const as BaseQLSelectionSet<EinzelberatungDataview>;
  }
}
